import React from 'react'
import { Container } from 'components/layout'
import { Term } from 'services/ContentfulService/models/term'
import { Breadcrumbs } from 'components/elements/Breadcrumbs'
import { GlossaryKeys } from './components/GlossaryKeys'
import { GlossaryList } from './components/GlossaryList'
import { GlossaryEmptyState } from './components/GlossaryEmptyState'
import { FALLBACK_KEY } from './utils'
import { Optional } from 'lib'
import { Text, View } from 'reshaped/bundle'

export interface Props {
	page: Optional<string>
	terms: Term[]
	validPages: string[]
}

export const GlossaryPage: React.FC<React.PropsWithChildren<Props>> = ({ terms, page = FALLBACK_KEY, validPages }) => {
	const breadcrumbs = [
		{ name: 'Learn', url: '/learn' },
		{ name: 'Glossary', url: '/learn/glossary' }
	]

	return (
		<Container>
			<Breadcrumbs breadcrumbs={breadcrumbs} />
			<View paddingTop={8}>
				<Text variant="title-3">Glossary</Text>
			</View>
			<View paddingTop={4} maxWidth="413px">
				<Text variant="body-2">
					We&apos;ve organized the most common financial terms and explained them in simple, friendly ways.
				</Text>
			</View>
			<GlossaryKeys page={page} validPages={validPages} />
			{terms.length > 0 ? <GlossaryList terms={terms} /> : <GlossaryEmptyState page={page} />}
		</Container>
	)
}
